<template>
  <aside class="monitoring-detail">
    <Panel class="l-flex-column" panel-class-name="monitoring-details-panel">
      <template #header>
        <sectionHeader title="details">
          <template #action>
            <div class="section-header--action" />
            <div class="section-header--action" />
          </template>
        </sectionHeader>
      </template>
      <template #content v-if="selectedTransferRowId === null">
        <div class="info-content scrollbar is-scrollable">
          <div class="info-block total">
            <div class="label">
              Transfers
            </div>
            <div class="value">
              {{ transferListInfo.total }}
            </div>
          </div>
          <div class="info-block">
            <div class="label">
              Active
            </div>
            <div class="value">
              {{ transferListInfo.active }}
            </div>
          </div>
          <div class="info-block">
            <div class="label">
              Inactive
            </div>
            <div class="value">
              {{ transferListInfo.inactive }}
            </div>
          </div>
        </div>
      </template>
      <template #content v-else>
        <Tabs
          class="info-tabs"
          :data-tabs="dataTabs"
          parent="transfers"
        >
          <template #content v-if="activeTab === 'information'">
            <TransferInformationTab :transfer-info="transferInfo" :audience-info="audienceInfo" />
          </template>
          <template #content v-else-if="activeTab === 'audience'">
            <TransferAudienceTab :audience-info="audienceInfo" />
          </template>
        </Tabs>
      </template>

      <template #footer v-if="isFooter">
        <div
          v-if="activeTab === 'information' && monitoringActionAllowed"
          class="delete-audience btn btn-delete btn--medium btn--round l-flex-row--center l-align-center"
          @click="deleteTransferHandler()"
        >
          <svg-icon name="trash" size="small" />
          Delete Transfer
        </div>
        <div
          v-if="activeTab === 'audience'"
          class="go-to-audience btn btn-border btn--medium btn--round l-flex-row--center l-align-center"
          @click="goToMonitoringAudience(audienceInfo.id)"
        >
          Go to audience
        </div>
      </template>
    </Panel>
  </aside>
</template>
<script>
// Avoid repeating namespace for each store action/mutation/getter/state
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

import { isEmpty, get, isNil, size, join } from 'lodash'

import { totalItemsByStatus } from '@/utils/helpers'
import dayjs from 'dayjs'

import { TRANSFER_DATATABS } from '@/utils/constants'


import Panel from '@/components/common/Panel'
import Tabs from '@/components/common/Tabs'
import SectionHeader from '@/components/common/SectionHeader'
import TransferInformationTab from './TransferInformationTab.vue'
import TransferAudienceTab from './TransferAudienceTab.vue'

export default {
    name: 'Details',

    components: {
        Panel,
        Tabs,
        SectionHeader,
        TransferInformationTab,
        TransferAudienceTab
    },

    props: {
        transferInfo: { type: Object, required: false, default: () => ({}) }
    },

    data() {
        return {
            displayEditSingleInput: {
                label: false,
                endDate: false,
                email: false,
                cc: false,
                tags: false,
                bootstrap: false
            },
            audienceFormLabel: null,
            audienceFormEndDate: null,
            audienceFormEmail: null,
            audienceFormCc: [],
            audienceTagsList: [],
            transferFormEndDate: {},
            transferFormLabel: {},
            transferFormCc: [],
            transferFormEmail: {}
        }
    },
    watch: {
        transferInfo: {
            handler: function(newValue) {
                if (!isNil(newValue.label)) {
                    this.audienceFormStatus = newValue.status
                    this.audienceFormLabel = newValue.label
                    this.audienceFormEndDate = dayjs(newValue.endDate).format('YYYY-MM-DD')
                    this.audienceFormEmail = newValue.email
                    this.audienceFormCc = isEmpty(newValue.cc) ? [] : newValue.cc.split(',')
                }
            },
            deep: true
        },
    },

    computed: {
        ...mapState('ui/transfers', {
            activeTab: state => state.activeTab,
            selectedTransferRowId: state => state.selectedTransferRowId
        }),
        ...mapState('account', {
            accountId: state => state.accountId
        }),
        ...mapState('data/transfer', {
            transferList: state => state.transferList,
            transferListByAudience: state => state.list
        }),
        ...mapState('data/audience', {
            audienceList: state => state.list,
        }),
        ...mapGetters('account', ['getIsMonitoringActionAllowed']),

        monitoringActionAllowed() {
            return this.getIsMonitoringActionAllowed()
        },

        //table audiences
        transferListInfo() {
            return {
                total: size(this.transferList),
                active: totalItemsByStatus(this.transferList, 'active'),
                inactive: totalItemsByStatus(this.transferList, 'inactive'),
            }
        },

        // Footer
        isFooter() {
            return this.selectedTransferRowId !== null
        },

        classModal() {
            let _classModal = ''
            if (this.displayTransferForm) _classModal = 'modal-h-full modal__medium modal-form-transfer'
            else if (this.displayExportForm) _classModal = 'modal-h-auto modal__medium modal-form-export'
            else if (this.displayVolumeAlertForm) _classModal = 'modal-h-auto modal__medium'
            else if (this.displayEditSingleInput.bootstrap) _classModal = 'modal-h-auto modal__small modal-formBootstrapAudience'

            return _classModal
        },

        dataTabs() {
            return TRANSFER_DATATABS
        },
        audienceInfo() {
            const audience = this.audienceList.find(({id}) => +id === +this.transferInfo.audience_id)
            if (isNil(audience)) return null
            return audience
        }
    },

    methods: {
        ...mapActions('data/audience', ['retrieveAudienceInfos', 'retrieveAudienceVolumeFromAudience', 'editAudience', 'retrieveVolumeAlert']),
        ...mapActions('data/settings', ['retrieveLinkedAccounts']),
        ...mapActions('data/transfer', ['editTransfer']),
        ...mapActions('account', ['retrieveAttributionCounterAudience', 'retrieveAttributionCounterTransfer']),
        ...mapMutations('exports', ['setExportForm']),
        ...mapMutations('ui/transfers', ['setDeletedTransfer', 'setDisplayModal', 'setActiveTab', 'setDeletedAudienceId', 'setSelectedAudienceHaveDeletedCriteria']),
        ...mapMutations('ui/monitoring', { setMonitoringActiveTab : 'setActiveTab' }),
        ...mapMutations('ui/monitoring', ['setSelectedRow']),
        /**
         * Trigger vuex action to get audience summary
         */
        handleRetrieveAudienceSummary() {
            this.retrieveAudienceInfos({
                type: 'summary',
                audienceId: this.audienceInfo.id,
                formula: this.audienceInfo.formula
            })
        },

        /**
         * Trigger vuex action to get audience breakdown
         */
        handleRetrieveAudienceBreakdown() {
            this.retrieveAudienceInfos({
                type: 'breakdown',
                audienceId: this.audienceInfo.id,
                formula: {
                    ids: [this.audienceInfo.id],
                    name: `audience_${this.audienceInfo.id}`,
                    type: 'Audience',
                    recency: '30'
                }
            })
        },

        // EXPORT DATA
        closeForm() {
            this.setDefaultVolumeAlertForm()
            this.setExportForm({ display: false, type: '' })
            this.setShowFormTransfer({ show: false })
            this.displayEditSingleInput = {
                tags: false,
                bootstrap: false
            }
            // reset
            if (this.selectedTransferRowId) {
                if (this.activeTab === 'information') {
                    this.audienceFormLabel = this.audienceInfo.label
                    this.audienceFormEndDate = dayjs(this.audienceInfo.endDate).format('YYYY-MM-DD')
                    this.audienceFormEmail = this.audienceInfo.email
                    this.audienceFormCc = isEmpty(this.transferInfo.cc) ? [] : this.transferInfo.cc.split(',')
                } else if (this.activeTab === 'transfers') {
                    this.transferFormLabel = null
                    this.transferFormEndDate = null
                    this.transferFormEmail = null
                    this.transferFormCc = []
                }
            }
        },

        // Modal single edit
        displayEdit(field, transfer) {
            if (this.monitoringActionAllowed) {
                if (transfer) {
                    // edit transfer
                    if (field === 'label') this.transferFormLabel = { ...this.transferFormLabel, [transfer.id]: transfer.label }
                    else if (field === 'endDate') this.transferFormEndDate = { ...this.transferFormEndDate, [transfer.id]: transfer.end_date }
                    else if (field === 'email') this.transferFormEmail[transfer.id] = transfer.email
                    else if (field === 'cc') this.transferFormCc = isEmpty(transfer.cc) ? [] : transfer.cc.split(',')

                    if (!isNil(get(this.displayEditSingleInput[field], 'id', null))) {
                        this.displayEditSingleInput[field][transfer.id] = true
                    } else {
                        this.displayEditSingleInput[field] = { [transfer.id]: true }
                    }
                } else {
                    this.displayEditSingleInput[field] = true //edit audience
                }
            }
        },

        editAudienceInfo(dataToEdit, newValue) {
            const {
                audienceFormLabel,
                audienceFormEndDate,
                audienceFormEmail,
                audienceFormCc,
                audienceInfo,
                selectedAudienceId,
                audienceTagsList,
                editAudience
            } = this

            const { displayEditSingleInput } = this

            if (this.monitoringActionAllowed) {
                this.$validator.validateAll().then(isValid => {
                    if (isValid) {
                        let _params
                        if (dataToEdit === 'endDate') _params = { params: { end_date: audienceFormEndDate }, notificationMessage: 'The date has been modified' }
                        else if (dataToEdit === 'email') _params = { params: { email: audienceFormEmail }, notificationMessage: 'The email has been modified' }
                        else if (dataToEdit === 'cc')
                            _params = { params: { email_cc: join(audienceFormCc, ',') }, notificationMessage: 'The email_cc has been modified' }
                        else if (dataToEdit === 'label') _params = { params: { label: audienceFormLabel }, notificationMessage: 'The label has been modified' }
                        else if (dataToEdit === 'bootstrap')
                            _params = { params: newValue, notificationMessage: 'The bootstrap ' + audienceInfo.label + ' has been added' }
                        else if (dataToEdit === 'audience-status') {
                            // if audience is set inactive, don't change the end date
                            if (!newValue) _params = { params: { status: 'inactive' }, notificationMessage: audienceInfo.label + ' has been set inactive' }
                            else {
                                const today = new Date()
                                const _endDate = new Date(audienceFormEndDate)
                                if (today.getTime() === _endDate.getTime() || _endDate < today) {
                                    // if audience is set active and the end date is today or before, change the end date (+ 30 days)
                                    const newEndDate = today.setDate(today.getDate() + 30)
                                    _params = {
                                        params: { status: 'active', end_date: dayjs(newEndDate).format('YYYY-MM-DD') },
                                        notificationMessage: audienceInfo.label + ' has been set active'
                                    }
                                } else {
                                    // if audience is set active and the end date after today, don't change the end date
                                    _params = { params: { status: 'active' }, notificationMessage: audienceInfo.label + ' has been set active' }
                                }
                            }
                        }

                        editAudience({ ..._params, id: selectedAudienceId, tags: audienceTagsList })

                        // close edit modal
                        if (dataToEdit !== 'audience-status') {
                            displayEditSingleInput[dataToEdit] = false
                        }
                    }
                })
            }
        },
        deleteTransferHandler() {
            this.setDisplayModal({ item: 'transfer', display: true })
            const audience = this.transferList.find(({ id }) => id === this.selectedTransferRowId)
            if(!isNil(audience)) {
                this.setDeletedTransfer({ transferId: this.selectedTransferRowId, audienceId: +audience.audience_id })
            }
        },
        displayEditSingleInputBootstrap() {
            this.displayEditSingleInput.bootstrap = true
        },
        goToMonitoringAudience(audienceId) {
            this.setSelectedRow({ rowId: null })
            this.setSelectedRow({ rowId: audienceId, from: 'other-page' })
            // this.setIsAudienceCcloneTargeted({ value: true })
            this.setMonitoringActiveTab({ tab: 'information' })
            this.$router.push({ path: '/' + this.accountId + '/monitoring/audiences' })
        }

    }
}
</script>
